export default __webpack_public_path__ + "static/media/main.d34ac3ab.jpg";